import { getIconComponent } from "@storytell/bsky-icons";
import { StButton } from "@storytell/ui/buttons";
import { TbX } from "solid-icons/tb";
import { Dynamic } from "solid-js/web";
import { twMerge } from "tailwind-merge";
import { isLightColor } from "../layouts/minimal/isLightColor";
import { truncateMiddle } from "~/utils/truncateMiddle";
import type { Label } from "@storytell/types";

export const LabelClosableButton = (props: {
  onClose: () => void;
  onClick: () => void;
  label: Label;
  class?: string;
}) => {
  return (
    <StButton
      onClick={props.onClick}
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      icon={(iconProps: any) => (
        <>
          <Dynamic
            component={getIconComponent(props.label.icon)}
            {...iconProps}
            class={twMerge(iconProps.class, "group-hover/label:hidden")}
          />
          <TbX
            {...iconProps}
            class={twMerge(iconProps.class, "hidden group-hover/label:block")}
            onClick={(e) => {
              e.preventDefault();
              e.stopImmediatePropagation();
              props.onClose();
            }}
          />
        </>
      )}
      class={twMerge("p-1 shrink-0 whitespace-nowrap group/label bg-tile hover:bg-tile-hover", props.class)}
      iconClass="size-4 p-0.5 rounded-full bg-[var(--label-color)] text-[var(--label-icon)]"
      style={{
        "--label-color": props.label.color,
        "--label-icon": isLightColor(props.label.color) ? "black" : "white",
      }}
    >
      {truncateMiddle(props.label.name)}
    </StButton>
  );
};
